import React from 'react';

// Cor única e discreta pra todos os títulos de seção (Identificação, Classificação, etc.),
// só pra separar visualmente do conteúdo, sem virar um arco-íris entre as abas.
const COR_TITULO = '#0891b2';

export default function Secao({ titulo, acao, children }) {
  return (
    <div>
      <div style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        borderBottom: `2px solid ${COR_TITULO}4D`, paddingBottom: 5, marginBottom: 9
      }}>
        <span style={{ fontSize: 11, fontWeight: 800, color: COR_TITULO, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
          {titulo}
        </span>
        {acao}
      </div>
      {children}
    </div>
  );
}
